var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import cn from "classnames";
import styles from "./Tooltip.module.css";
import { ThemeContext, ThemeFactory, Tooltip as ReactUiTooltip, } from "@skbkontur/react-ui";
import { KonturColors as Colors } from "@skbkontur/colors";
var TooltipStepTheme = ThemeFactory.create({
    tooltipBorderRadius: "16px",
    tooltipCloseBtnPadding: "8px",
});
var BlueTooltipStepTheme = ThemeFactory.create({
    tooltipBg: Colors.blue0Logo,
    tooltipBorderRadius: "16px",
    tooltipCloseBtnColor: "rgba(255, 255, 255, 0.374)",
    tooltipCloseBtnHoverColor: "white",
    tooltipCloseBtnPadding: "8px",
    tooltipTextColor: "white",
});
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hasElem: true };
        return _this;
    }
    Tooltip.prototype.componentWillMount = function () {
        if (!this.props.anchorElement()) {
            this.setState({ hasElem: false });
        }
    };
    Tooltip.prototype.render = function () {
        var _this = this;
        if (!this.state.hasElem) {
            return React.createElement("span", null);
        }
        var partOfTheme = this.props.blueBackground
            ? BlueTooltipStepTheme
            : TooltipStepTheme;
        var themeValue = __assign(__assign({}, partOfTheme), { tooltipMargin: "".concat(this.props.offset, "px") });
        return (React.createElement(ThemeContext.Provider, { value: ThemeFactory.create(themeValue) },
            React.createElement(ReactUiTooltip, { onCloseRequest: this.props.onClose, trigger: "opened", allowedPositions: this.props.allowedPositions, pos: (this.props.allowedPositions && this.props.allowedPositions[0]) ||
                    "bottom center", anchorElement: this.props.anchorElement(), render: function () {
                    return (React.createElement("div", { className: cn(styles.tooltip, _this.props.blueBackground && styles.blueTooltip), style: { width: _this.props.width } }, _this.props.render()));
                } })));
    };
    Tooltip.prototype.componentDidMount = function () {
        if (!this.state.hasElem) {
            this.props.onSkip && this.props.onSkip();
        }
    };
    Tooltip.defaultProps = {
        allowedPositions: ["bottom center"],
        width: 368,
        offset: 24,
        onClose: function () { },
    };
    Tooltip.Container = Container;
    Tooltip.Header = Header;
    Tooltip.Body = Content;
    Tooltip.Footer = Footer;
    Tooltip.Image = Image;
    return Tooltip;
}(React.Component));
export { Tooltip };
export function Container(_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.container }, children);
}
export function Header(_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.header }, children);
}
export function Content(_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.body }, children);
}
function Footer(_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.footer }, children);
}
function Image(_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.image }, children);
}
